import React from 'react';
import FormSection from './form-section';
import LeftLoginSection from 'pages/auth/login/left-login-section';

const ResetPassword = () => {
  return (
    <div className='flex md:flex-row flex-col md:h-[100vh]'>
      <LeftLoginSection />
      <FormSection />
    </div>
  );
};

export default ResetPassword;
